import PostRegistration from './PostRegistration';

export default PostRegistration;
